import { css, etiColors, cx } from '@eti/styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const wingWrapperStyles = css`
  fill: ${etiColors.grayScale[6]};
  height: 2.625rem;
`;
const emptyRowStyles = css`
  height: 1.5rem;
`;
const wingIcon = css`
  height: 3.75rem;
  pointer-events: none;
  width: 1.875rem;
`;
const LeftWing = () => /*#__PURE__*/_jsx("svg", {
  className: wingIcon,
  "data-testid": "leftWing",
  viewBox: "0 0 64 128",
  children: /*#__PURE__*/_jsx("path", {
    d: "M0 32 V128 L64 96 V0 L0 32z"
  })
});
const RightWing = () => /*#__PURE__*/_jsx("svg", {
  className: wingIcon,
  "data-testid": "rightWing",
  viewBox: "0 0 64 128",
  children: /*#__PURE__*/_jsx("path", {
    d: "M0 0 V96 L64 128 V32 L0 0z"
  })
});
const Wing = _ref => {
  let {
    isLeft,
    isRight,
    isEmptyRow
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: cx(wingWrapperStyles, isEmptyRow && emptyRowStyles),
    children: [isLeft && /*#__PURE__*/_jsx(LeftWing, {}), isRight && /*#__PURE__*/_jsx(RightWing, {})]
  });
};
export default Wing;
//# sourceMappingURL=Wing.js.map